import * as React from 'react';

import PropTypes from 'prop-types';

export default class TouchableArea extends React.Component {
    static propTypes = {
        scroller: PropTypes.object.isRequired,
        children: PropTypes.element.isRequired,
        touchable: PropTypes.bool,
    };

    static defaultProps = {
        touchable: true,
    };

    render() {
        return (
            <div
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                onTouchCancel={this.handleTouchEnd}
            >
                {this.props.children}
            </div>
        );
    }

    handleTouchStart = (e) => {
        if (!this.props.scroller || !this.props.touchable) {
            return;
        }

        this.props.scroller.doTouchStart(e.touches, e.timeStamp);
    };

    handleTouchMove = (e) => {
        if (!this.props.scroller || !this.props.touchable) {
            return;
        }

        this.props.scroller.doTouchMove(e.touches, e.timeStamp, e.scale);
    };

    handleTouchEnd = (e) => {
        if (!this.props.scroller || !this.props.touchable) {
            return;
        }

        this.props.scroller.doTouchEnd(e.timeStamp);
    };
}
